import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "twr_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((i) => i.id === product.id);
      if (idx >= 0) {
        const copy = [...cur];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + qty };
        return copy;
      }
      return [...cur, { id: product.id, name: product.name, price: product.price, image: product.image, quantity: qty }];
    });
  };

  const remove = (id) => setItems((cur) => cur.filter((i) => i.id !== id));
  const setQty = (id, qty) => setItems((cur) => cur.map((i) => (i.id === id ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    return { count, subtotal };
  }, [items]);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, totals }}>{children}</CartCtx.Provider>
  );
}

export function useCart() {
  const v = useContext(CartCtx);
  if (!v) throw new Error("useCart must be inside CartProvider");
  return v;
}
